import { render } from "./CopyrightView.vue?vue&type=template&id=4658a4b2&scoped=true"
const script = {}

import "./CopyrightView.vue?vue&type=style&index=0&id=4658a4b2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/lumaa.fr/lumaa.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4658a4b2"]])

export default __exports__